import CardsRender from './CardsRender';

export default CardsRender;
